/*!
 * Copyright (c) 2026 GS Elektromedizinische Geraete G. Stemple GmbH, Germany - all rights reserved.
 * <p>
 * DO NOT ALTER OR REMOVE COPYRIGHT NOTICES OR THIS FILE HEADER.
 */

@use '../../../../variables';

#PageFooter {
  height: variables.$page-footer-height;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: variables.$margin-medium;
  padding: variables.$margin-medium;

  button.MuiButtonBase-root {
    height: variables.$footer-button-height;
    border-radius: variables.$footer-button-height;
    color: variables.$color-black;
    font-weight: normal;

    &:hover {
      background-color: variables.$footer-button-color-hover;
    }
  }

  button.navigation-next {
    padding: 3px 3px 3px 15px;

    .next-label {
      max-width: 300px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }

    span.MuiButton-icon {
      width: variables.$footer-button-height;
      height: variables.$footer-button-height;
      background-color: variables.$color-orange;
      color: white;
      border-radius: variables.$footer-button-height;
      padding: 17px;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }

  button.no-path-button {
    padding: 3px 15px 3px 3px;

    .MuiButton-startIcon {
      background-color: variables.$background-color-hover;
      width: variables.$footer-button-height;
      height: variables.$footer-button-height;
      padding: 3px;
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: variables.$footer-button-height;
    }

    &.MuiButton-contained {
      background-color: variables.$color-corpuls-system-green-lightest;

      .MuiButton-startIcon {
        background-color: variables.$color-corpuls-system-green;
      }
    }
  }

  .left-side,
  .right-side {
    width: 50%;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
}
